import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {registerAxiosInterceptor} from "./Utility/Utility";
import  config from "./Utility/Config"
registerAxiosInterceptor();

config.register().then(() => {
    ReactDOM.render(<App />, document.getElementById("root"));
    serviceWorker.unregister();
  });
  
